/**
 * Created by Ivan on 10.08.2026
 */

const RewardStickerView2 = function (sticker) {
    return Prefab.instantiate(bundles.stickers2_reward_window.jsons.reward_sticker_prefab_json, { sticker });
};
